var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCardOnDeliveryCartCheckout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 10.6666H10.667V16H21.3337V10.6666Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 1.33337H10V6.66671H22V1.33337Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0663 30.6666C23.5818 30.6666 23.9997 30.2189 23.9997 29.6666V22.8333L25.333 17.3333V7.66663C25.333 7.11434 24.9151 6.66663 24.3997 6.66663L7.59967 6.66663C7.08421 6.66663 6.66634 7.11434 6.66634 7.66663V17.3333L7.99967 22.8333V29.6666C7.99967 30.2189 8.41754 30.6666 8.93301 30.6666H23.0663Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.167 22.6666C12.9954 22.6666 13.667 21.9951 13.667 21.1666C13.667 20.3382 12.9954 19.6666 12.167 19.6666C11.3386 19.6666 10.667 20.3382 10.667 21.1666C10.667 21.9951 11.3386 22.6666 12.167 22.6666Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.167 22.6666C16.9954 22.6666 17.667 21.9951 17.667 21.1666C17.667 20.3382 16.9954 19.6666 16.167 19.6666C15.3386 19.6666 14.667 20.3382 14.667 21.1666C14.667 21.9951 15.3386 22.6666 16.167 22.6666Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.167 22.6666C20.9954 22.6666 21.667 21.9951 21.667 21.1666C21.667 20.3382 20.9954 19.6666 20.167 19.6666C19.3386 19.6666 18.667 20.3382 18.667 21.1666C18.667 21.9951 19.3386 22.6666 20.167 22.6666Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.167 27.6666C12.9954 27.6666 13.667 26.9951 13.667 26.1666C13.667 25.3382 12.9954 24.6666 12.167 24.6666C11.3386 24.6666 10.667 25.3382 10.667 26.1666C10.667 26.9951 11.3386 27.6666 12.167 27.6666Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.167 27.6666C16.9954 27.6666 17.667 26.9951 17.667 26.1666C17.667 25.3382 16.9954 24.6666 16.167 24.6666C15.3386 24.6666 14.667 25.3382 14.667 26.1666C14.667 26.9951 15.3386 27.6666 16.167 27.6666Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.167 27.6666C20.9954 27.6666 21.667 26.9951 21.667 26.1666C21.667 25.3382 20.9954 24.6666 20.167 24.6666C19.3386 24.6666 18.667 25.3382 18.667 26.1666C18.667 26.9951 19.3386 27.6666 20.167 27.6666Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.667,
    y1: 1.33337,
    x2: 17.667,
    y2: 6.66671,
    stroke: "black",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardOnDeliveryCartCheckout);
export default __webpack_public_path__ + "static/media/icon-card-on-delivery-cart-checkout.ad663cd4bbbfc70da9e786bdae54987c.svg";
export { ForwardRef as ReactComponent };